<template>
  <div class="pa-4 report-filters">
    <template v-for="(config, key) in report.controls">
      <div
        :key="key"
        v-if="controlComponent(key, config)"
        class="mb-3"
        :class="{ 'locked-control': isLocked(config) }"
      >
        <component
          :schema="controlSchema(config)"
          :is="controlComponent(key, config)"
          @input="setInput(config, $event)"
          :value="inputValue(config)"
        />
      </div>
    </template>
  </div>
</template>

<script>
import {
  getControlComponent,
  buildControlSchema,
  getInputValue,
  parseInputEvent,
} from './reportControlsHelper';

import ReportTrackerNames from './controls/ReportTrackerNames';
import ReportGroups from './controls/ReportGroups';
import ReportContactField from './controls/ReportContactField';
import ReportCampaign from './controls/ReportCampaign';
import ReportOptionList from './controls/ReportOptionList';
import ReportContacts from './controls/ReportContacts';
import ReportCustomObjects from './controls/ReportCustomObjects';
import ReportTimeframe from './controls/ReportTimeframe';
import ReportOfficePattern from './controls/ReportOfficePattern';
import ReportObject from './controls/ReportObject';
import ReportContactFilter from './controls/ReportContactFilter';

import DateField from '@/components/formFields/DateField';
import TextField from '@/components/formFields/TextField';
import NumberField from '@/components/formFields/NumberField';
import CheckboxField from '@/components/formFields/CheckboxField';
import UserListField from '@/components/formFields/UserListField';

export default {
  name: 'ReportControls',
  components: {
    ReportTrackerNames,
    ReportGroups,
    ReportContactField,
    ReportCampaign,
    DateField,
    TextField,
    NumberField,
    CheckboxField,
    ReportOptionList,
    ReportContacts,
    ReportCustomObjects,
    UserListField,
    ReportTimeframe,
    ReportOfficePattern,
    ReportObject,
    ReportContactFilter,
  },
  props: {
    value: {},
    filters: {
      type: Object,
      default: () => ({}),
    },
    canUpdate: {
      type: Boolean,
      default: false,
    },
    report: {
      type: Object,
      default: () => ({}),
    },
    lockedParams: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {};
  },

  computed: {
    modalState: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },

  methods: {
    inputValue(config) {
      return getInputValue(this.filters, config);
    },

    controlSchema(config) {
      return buildControlSchema(config, { dark: !this.isMobile });
    },

    controlComponent(key, config) {
      return getControlComponent(key, config);
    },

    isLocked(config) {
      return this.lockedParams.includes(config.param);
    },

    setInput(config, event) {
      const { param, value } = parseInputEvent(config, event);

      if (param && value !== undefined) {
        this.checkDateFilterChanges(param, value);
        this.$emit('updateInput', param, value);
      }
    },

    // reset date filter if start_date is greater than end_date
    checkDateFilterChanges(param, value) {
      const isDateFilter = ['start_date', 'end_date'].includes(param);
      if (!isDateFilter || !value) return;

      const isStartDate = param === 'start_date';
      const dateToCheckType = isStartDate ? 'end_date' : 'start_date';

      if (!this.filters[dateToCheckType]) return;

      const currentDate = new Date(value);
      const dateToCheck = new Date(this.filters[dateToCheckType]);

      const shouldResetDate = isStartDate
        ? currentDate > dateToCheck
        : currentDate < dateToCheck;

      if (shouldResetDate) {
        this.$emit('updateInput', dateToCheckType, '');
      }
    },

    reload() {
      this.$emit('reload');
      this.modalState = false;
    },
  },
};
</script>

<style lang="less">
.update-report {
  position: sticky;
  bottom: 10px;
}

.report-filters .field__inner-title {
  display: none;
}

.locked-control {
  pointer-events: none;
  opacity: 0.5;
}
</style>
